"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import PostModal from "@/components/detail/ClientPostDetail";
import { Post } from "@/types";

interface PostPageClientProps {
  post: Post;
  detail?: boolean;
  qualityComments?: any[];
}

export default function PostPageClient({ post, detail = false, qualityComments = [] }: PostPageClientProps) {
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleCloseModal = () => {
    router.push("/");
    setIsModalOpen(false);
    // Navigate back to home page
  };

  useEffect(() => {
    // Open modal on page load
    setIsModalOpen(true);
  }, []);
  if (!post) return null;
  return (
    <PostModal
      post={post as Post & { up: number, isLiked: boolean, isNowLiked: boolean }}
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      detail={detail}
      qualityComments={qualityComments}
    />
  );
}
